// enterpriseContact.js
// PRD-146 WP3 — Enterprise is the ONLY email-to-scope flow. The CTA's single job
// is to scope sizing (the actual Enterprise pricing levers: asset/subnet counts +
// scan cadence), so the mailto pre-fills a sizing template rather than a generic
// "inquiry". Standard/Pro never email — they are 100% self-serve checkout.

const ENTERPRISE_SIZING_SUBJECT = 'Enterprise sizing';

const ENTERPRISE_SIZING_BODY = [
  'Hi DriftAlarm team — we\'d like an Enterprise quote. Here is our scope:',
  '',
  '• Number of domains to monitor: ',
  '• Number of /24 subnets (IP ranges): ',
  '• Approximate number of internet-facing hosts: ',
  '• Desired scan cadence (e.g. daily vuln, weekly discovery): ',
  '• Any compliance / reporting requirements: ',
  '• Company name: ',
  '',
  'Thanks!',
].join('\n');

// mailto: with a pre-filled sizing subject + body. Encoded so newlines/spaces
// survive in every mail client.
export const ENTERPRISE_SIZING_MAILTO =
  `mailto:sales@driftalarm.com?subject=${encodeURIComponent(ENTERPRISE_SIZING_SUBJECT)}` +
  `&body=${encodeURIComponent(ENTERPRISE_SIZING_BODY)}`;

export default ENTERPRISE_SIZING_MAILTO;
